import { post } from '../../util/fetch';
import { LoginForm } from '../../components/intro/useLoginForm';
import { LoginResponse, LoginResponseV2 } from './LoginResponse';

export const login = (request: LoginForm) => {
  return post<LoginResponse>('/api/v1/administrator/login', request);
};

export const loginV2 = (request: LoginForm) => {
  return post<LoginResponseV2>('/api/v2/administrator/login', request);
};

// 토큰을 쿠키에서 지우기 전에 호출해야 Authorization 헤더가 붙는다
export const logoutRequest = () => {
  return post('/api/v1/administrator/logout')
}
